const getPublicUrl = () => {
  const url = process.env.NEXT_PUBLIC_SITE_URL || process.env.NEXT_PUBLIC_URL;
  if (url && url.trim() !== '') return url;
  return 'https://molwe.ru';
};

const getApiUrl = () => {
  const url = process.env.NEXT_PUBLIC_API;
  if (url && url.trim() !== '') return url;
  return 'https://api-fanfic.staging.lorium.online';
};

const getDeployDate = () => {
  const date = process.env.NEXT_PUBLIC_DEPLOY_DATE;
  if (date && date.trim() !== '') return date;
  return new Date().toISOString();
};

export default {
  PUBLIC_URL: getPublicUrl(),
  API_URL: getApiUrl(),
  DEPLOY_DATE: getDeployDate(),
};
